
























































import { Component, Emit, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';

@Component
export default class FilterSelect extends Vue {
  @PropSync('isShow', { type: Boolean }) syncedIsShow!: boolean;

  @Prop({ type: String, default: '' }) filterName!: string;
  @Prop({ type: Array, default: () => [] }) arrayData!: any;
  @Prop({ type: Array, default: () => [] }) filterStack!: any;
  @Prop({ type: Boolean, default: true }) isSearch!: boolean;
  @Prop({ type: Function }) showOnlyOneFilterSelect!: Function;

  public mainArray: any = [];
  public subArray: any = [];
  public stash: any = this.filterStack;
  public defaultProps = {
    children: 'fkLocationSub',
    label: 'name',
  };
  public filterText: string = '';

  @Watch('filterText')
  onFilterText(c: any, p: any) {
    (this.$refs.tree as any).filter(c);
  }

  @Emit('emitCheckFilterItem')
  checkFilter(item: any, chkItem: any) {
    if (this.filterName === 'Locations') {
      let processedStash: any = [];
      let shouldDeleteSubLocation: boolean = false;
      let count: number = 0;
      let limitOfCount: number = 0;
      let stash = chkItem.checkedNodes;

      for (let i = 0; i < stash.length; i += 1) {
        processedStash.push(stash[i]);
        if (shouldDeleteSubLocation) {
          processedStash.pop();
          count += 1;
        }
        if (stash[i].hasOwnProperty('fkLocationSub') && !!stash[i].fkLocationSub.length) {
          shouldDeleteSubLocation = true;
          limitOfCount = stash[i].fkLocationSub.length;
        } else if (!!limitOfCount && count === limitOfCount) {
          shouldDeleteSubLocation = false;
          count = 0;
          limitOfCount = 0;
        }
      }

      this.mainArray = processedStash
        .filter((item: any) => item.hasOwnProperty('fkLocationSub'))
        .map((v: any) => v.id);
      this.subArray = processedStash
        .filter((item: any) => !item.hasOwnProperty('fkLocationSub'))
        .map((v: any) => v.id);
      this.stash = [...processedStash];

      return {
        stash: this.stash,
        filterName: this.filterName,
        mainArray: this.mainArray,
        subArray: this.subArray,
      };
    } else {
      this.stash = [...chkItem.checkedNodes];
      this.subArray = this.stash.map((item: any) => item.id);
      return {
        stash: this.stash,
        filterName: this.filterName,
        subArray: this.subArray,
      };
    }
  }

  filterNode(value: any, data: any, node: any) {
    if (!value) return true;
    if (data.name.indexOf(value) !== -1) {
      return true;
    }
    return this.checkBelongToChooseNode(value, data, node);
  }

  checkBelongToChooseNode(value: any, data: any, node: any) {
    const level = node.level;
    if (level === 1) return false;
    let parentData = node.parent;
    let index = 0;
    while (index < level - 1) {
      if (parentData.data.name.indexOf(value) !== -1) return true;
      parentData = parentData.parent;
      index++;
    }
    return false;
  }

  async mounted() {
    await this.anyWhereClose('selectLayer');
    this.$root.$on('rootResetFilter', (bool: boolean) => {
      this.stash = [];
      this.mainArray = [];
      this.subArray = [];
    });
  }

  anyWhereClose(refName: string) {
    document.addEventListener('click', (e: any) => {
      if ((this.$refs[refName] as HTMLElement) !== undefined) {
        if (
          this.filterName !== e.target.dataset.filterName &&
          !e.target.dataset.hasOwnProperty('filterButton') &&
          !(this.$refs[refName] as HTMLElement).contains(e.target)
        ) {
          this.$emit('update:isShow', false);
        }
      }
    });
  }
}
